<template>
  <div>
    <EmployeeList></EmployeeList>
  </div>
</template>

<script>
import EmployeeList from "@/components/employee/EmployeeList";

export default {
  components: {
    EmployeeList,
  },
};
</script>

<style></style>
